module.exports = __webpack_public_path__ + "static/media/laurenminointeriors - 4.5fb6cb1a.jpg";